import { Preview } from "@creatomate/preview";

import { GENERIC_ELEMENT, IMAGE_TYPE, VIDEO_TYPE } from "../constants";
import isStoryElement from "../isStoryElement";

const isHttpsUrl = (url: string | undefined): boolean => url !== undefined && url.startsWith("https://");
const isValidMediaType = (type: string | undefined): boolean => (
  type === VIDEO_TYPE || type === IMAGE_TYPE
);
const isNotLogo = (name: string | undefined): boolean => name === undefined || !name.toLowerCase().includes("logo");
const isNotAsset = (url: string): boolean => !url.toLowerCase().includes("culturehq-assets"); // intros or outros videos

const isNotOutroOrIntro = (
  name: string | undefined
): boolean => name === undefined
|| (!name.includes(GENERIC_ELEMENT.OUTRO) && !name.includes(GENERIC_ELEMENT.INTRO));

const getMediaElements = (mediaType: string, preview: Preview | undefined) => {
  if (!preview) return [];
  if (mediaType === VIDEO_TYPE) {
    return preview.state?.elements.filter(
      ({ source }) => isHttpsUrl(source.source)
          && isValidMediaType(source.type)
          && isNotLogo(source.name)
          && isNotAsset(source.source)
          && isNotOutroOrIntro(source.name)
          && isStoryElement(source)
    );
  }

  return preview.state?.elements.filter(
    ({ source }) => source.source?.startsWith("https://") && source.type === "image"
  );
};

export default getMediaElements;
